import { c as _c } from "react/compiler-runtime";
import type { Data } from '@repo/strapi-types';
import { useTranslations } from 'next-intl';
import AppLink from '@/components/elementary/AppLink';
import { Tag } from '@/components/elementary/Tag';
import { BasicImage } from '@/components/page-builder/components/BasicImage';
import { Paragraph } from '@/components/typography/Paragraph';
import { cn } from '@/lib/styles';
import styles from './NavbarMenuLink.module.css';
interface NavbarMenuLinkProps {
  readonly link: Data.Component<'layout-utilities.navbar-links'>;
  readonly isDropDownItem?: boolean;
  readonly stackIcon?: boolean;
  readonly testId?: string;
  onClick?: () => void;
}
export function NavbarMenuLink(t0) {
  const $ = _c(32);
  const {
    link,
    isDropDownItem: t1,
    stackIcon: t2,
    testId,
    onClick
  } = t0;
  const isDropDownItem = t1 === undefined ? false : t1;
  const stackIcon = t2 === undefined ? false : t2;
  const t = useTranslations("Navbar");
  const shouldStackIcon = stackIcon && link.icon;
  const t3 = link.id;
  const t4 = shouldStackIcon && "lg:flex-col lg:items-start";
  let t5;
  if ($[0] !== t4) {
    t5 = cn("flex gap-2 w-fit flex-row items-center", t4);
    $[0] = t4;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  let t6;
  if ($[2] !== link.hasPeachIconBackground || $[3] !== link.icon) {
    t6 = link.icon && <div className={cn("flex justify-center shrink-0 size-8 items-center p-1.25 border border-neutral-light-400 rounded", link.hasPeachIconBackground ? "bg-peach-200" : "bg-transparent")}><div className="relative size-6 shrink-0"><BasicImage component={link?.icon} className="object-contain" fill={true} ignoreMediaSize={true} /></div></div>;
    $[2] = link.hasPeachIconBackground;
    $[3] = link.icon;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  const t7 = isDropDownItem ? "flex-col" : "gap-1.5";
  let t8;
  if ($[5] !== t7) {
    t8 = cn("flex", t7);
    $[5] = t7;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  let t9;
  if ($[7] !== isDropDownItem || $[8] !== link.newTag || $[9] !== link.title || $[10] !== t) {
    t9 = link?.title && <Paragraph fontSize="bodyRegularMedium" className={cn("text-inherit", isDropDownItem ? styles["nav-content-dropdown-link"] : styles["nav-content-menu-link"])}>{link.title}{!isDropDownItem && link?.newTag && <Tag name={t("newBadge")} variant="green-success" size="small" className="ml-1.5" />}</Paragraph>;
    $[7] = isDropDownItem;
    $[8] = link.newTag;
    $[9] = link.title;
    $[10] = t;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== isDropDownItem || $[13] !== link.description) {
    t10 = link?.description && !isDropDownItem && <Paragraph className={cn("text-inherit whitespace-nowrap", styles["nav-content-menu-link"])}>{link.description}</Paragraph>;
    $[12] = isDropDownItem;
    $[13] = link.description;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== t10 || $[16] !== t8 || $[17] !== t9) {
    t11 = <div className={t8}>{t9}{t10}</div>;
    $[15] = t10;
    $[16] = t8;
    $[17] = t9;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t11 || $[20] !== t5 || $[21] !== t6) {
    t12 = <div className={t5}>{t6}{t11}</div>;
    $[19] = t11;
    $[20] = t5;
    $[21] = t6;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== isDropDownItem || $[24] !== link.description) {
    t13 = link?.description && isDropDownItem && <Paragraph fontSize="bodyRegularMedium">{link.description}</Paragraph>;
    $[23] = isDropDownItem;
    $[24] = link.description;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== link || $[27] !== onClick || $[28] !== t12 || $[29] !== t13 || $[30] !== testId) {
    t14 = <AppLink variant="primaryLink" size="none" link={link} key={t3} className="flex flex-col gap-2 w-fit items-start" data-test-id={testId} onClick={onClick}>{t12}{t13}</AppLink>;
    $[26] = link;
    $[27] = onClick;
    $[28] = t12;
    $[29] = t13;
    $[30] = testId;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  return t14;
}